<template>
	<div class="notes-view-root">
		<div>
			<div class="card p-2" v-if="isAnswerMode || isDemoMode">
				<el-input
					type="textarea"
					:autosize="{ minRows: 2, maxRows: 100}"
					resize="none"
					:placeholder="placeholder"
					@keydown.tab.prevent="tabber($event)"
					v-model="newNoteText">
				</el-input>
				<div class="row pr-4 pb-3 pt-2">
					<div class="layout-spacer"></div>
					<ToolTipView :disabled="newNoteText.length !== 0">
						<template #icon>
							<el-button  :disabled="newNoteText.length === 0" type="primary" size="small" @click="createNote">
								<span>Add note</span>
							</el-button>
						</template>
						Start typing to add a new note
					</ToolTipView>
				</div>
			</div>
			<div class="py-5"></div>

			<div class="card mb-3" v-for="(note, index) in noteListData" :key="index">
				<div class="row p-3">
					<div class="small text-muted p-3">
						Created on <span>{{dateFormatted(note.createdAt)}}</span>
					</div>
					<div class="layout-spacer"></div>
					<i v-if="isAnswerMode || isDemoMode" class="fontello icon-trash pointer mr-3" @click="deleteNote(note, index)"/>

				</div>
				<div v-if="isViewMode && !isDemoMode" class="preserve-new-lines px-3">
					{{note.text}}
				</div>
				<div
					v-else
					class="px-2 input-highlight"
					:class="[{isEditing: note._isEditing}]">

					<el-input
						type="textarea"
						:autosize="{ minRows: 2, maxRows: 100}"
						resize="none"
						placeholder="Start typing to leave a private note..."
						v-model="note.text"
						@input="onInput($event, note)"
						@keydown.tab.prevent="tabber($event)"
						@focus="onFocus(note)"
						@blur="updateNote(note, index)">
					</el-input>
					<i class="fontello icon-pencil input-highlight-icon"></i>
				</div>
				<div class="row pr-4 pb-3 pt-2">
					<div class="layout-spacer"></div>
					<el-button v-if="note._isEditing" type="primary" size="small" @click="updateNote(note, index)">
						<span>Save changes</span>
					</el-button>
				</div>
			</div>

		</div>

	</div>

</template>

<script>

	import moment from 'moment'

	import NoteItem from "@/core/js/model/Profile/NoteItem";

	import {copyObject} from "@/utils/helpers";
	import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
	import ViewModeComponent from "@/core/components/ViewModeComponent.vue";


	export default {
		name: 'NotesView',
		components: {ToolTipView},
		extends: ViewModeComponent,
		props: {
            noteList: Array,
			placeholder: {type: String, default: "Start typing to add a private note..."}
		},
        watch: {
            noteList: {
				immediate: true,
				handler (noteListData, oldVal) {
					console.log("noteListData = ", noteListData)
					let copy = copyObject(NoteItem, noteListData)
					this.noteListData = copy

				}
	        }
        },
		data() {
			return {
				newNoteText: "",
                noteListData: []
			}
		},

		computed: {

		},


		methods: {
			resetEditing(){
				this.noteListData.forEach(note => note._isEditing = false)
			},
			onInput(event, note) {
				// param.text = event
				note._changed = true
				this.$forceUpdate()
			},
			createNote() {
                let _ = this.$analyticManager.trackEvent("Note created", this.analyticsPropsMethod())
				let note = new NoteItem()
				note.text = this.newNoteText
				note.authorId = this.userProfile.id
				note.authorName = this.userProfile.name

                this.noteListData.unshift(note)
				this.$emit("createNote", note)

                this.newNoteText = ""
                // this.$forceUpdate();

			},
			updateNote(note) {
                let _ = this.$analyticManager.trackEvent("Note updated", this.analyticsPropsMethod())

                note.lastModified = new Date().getTime()
                note._changed = false
                let index = this.findNoteIndexByNote(note)
                if(index >= 0){
                    this.noteListData.splice(index, 1, note)
                }
                this.$forceUpdate()
				this.resetEditing()
				this.$emit("updateNote", note, index)
			},
			deleteNote(note) {
                let _ = this.$analyticManager.trackEvent("Note deleted", this.analyticsPropsMethod())
                let index = this.findNoteIndexByNote(note)
				if(index >= 0){
                    this.noteListData.splice(index, 1)
				}
				this.resetEditing()

				this.$emit("deleteNote", note, index)
            },

			findNoteIndexByNote(note){
			    return this.noteListData.findIndex(item => {
			        return item.id == note.id
				})
			},

            tabber (event) {
                let text = this.chapter.text,
                    originalSelectionStart = event.target.selectionStart,
                    textStart = text.slice(0, originalSelectionStart),
                    textEnd =  text.slice(originalSelectionStart);

                this.chapter.text = `${textStart}\t${textEnd}`
                event.target.value = this.chapter.text // required to make the cursor stay in place.
                event.target.selectionEnd = event.target.selectionStart = originalSelectionStart + 1
            },

			onFocus(note){
				if(this.isAnswerMode){
					note._isEditing = true;
					this.$forceUpdate()
				}
			},

			dateFormatted(date) {
				return moment(date).format("MMM DD, YYYY [at] hh:mma")
			}


		},

		created() {

		},

	}
</script>


<style lang="scss">
.notes-view-root{
	textarea {
		border: none !important;
	}
}


</style>



